export default __webpack_public_path__ + "static/media/M1A_6.3735e4d4.png";